export default __webpack_public_path__ + "static/media/ic_minus.b2512b4b.svg";